let Widget3dsoft = require('./Main.js');

/**
 * 
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormValidation = function (self) {
    if (self.verifStepClientDone()) {
        $(self.sClass + ' .widget3Dsoft-loading').show();

        self.ajax('GET',
            this.sServerURL + 'widget/form-validation' + this.sParamsGet, {},
            function (response, statut) {
                $(self.sClass).html(response);
                self.filArianne(self, 'stepValidation');

                var bAllStepValid = true; //Indique que toutes les Ã©tapes sont ok
                //Client
                if (self.rendezvous.sNom !== null && self.rendezvous.sNom !== '') {
                    //$(self.sClass + ' .widget3Dsoft-civilite').html(self.rendezvous.civilite);
                    if (self.rendezvous.sNom != null) {
                        $(self.sClass + ' .widget3Dsoft-nom').html(self.strip_tags(self.rendezvous.sNom));
                    }
                    
                    if (self.rendezvous.sPrenom != null) {
                        $(self.sClass + ' .widget3Dsoft-prenom').html(self.strip_tags(self.rendezvous.sPrenom));
                    }

                    if (self.rendezvous.adresse != null) {
                        $(self.sClass + ' .widget3Dsoft-adresse').html(self.strip_tags(self.rendezvous.adresse));
                    }

                    if (self.rendezvous.cp != null) {
                        $(self.sClass + ' .widget3Dsoft-cp').html(self.rendezvous.cp);
                    }

                    if (self.rendezvous.ville != null) {
                        $(self.sClass + ' .widget3Dsoft-ville').html(self.strip_tags(self.rendezvous.ville));
                    }

                    if (self.rendezvous.email != null) {
                        $(self.sClass + ' .widget3Dsoft-email').html(self.rendezvous.email);
                    }

                    if (self.rendezvous.telbur != null) {
                        $(self.sClass + ' .widget3Dsoft-telbur').html(self.rendezvous.telbur);
                    }

                    if (self.rendezvous.telmob != null) {
                        $(self.sClass + ' .widget3Dsoft-telmob').html(self.rendezvous.telmob);
                    }

                    if (self.rendezvous.teldom != null) {
                        $(self.sClass + ' .widget3Dsoft-teldom').html(self.rendezvous.teldom);
                    }
                }

                //STEP VEHICULE

                //self.aMarque[].libelle 

                if (self.rendezvous.iIdVehicule !== null) {
                    iIdVehicule = self.rendezvous.iIdVehicule;
                    var sMarque = self.aVehicules[iIdVehicule]._VEH_LIBELLE_MARQUE;
                    var sModele = self.aVehicules[iIdVehicule]._VEH_LIBELLE_MODELE;
                    $(self.sClass + ' .widget3Dsoft-modele').html(sMarque);
                    $(self.sClass + ' .widget3Dsoft-marque').html(sModele);
                    $(self.sClass + ' .widget3Dsoft-immatriculation').html(self.rendezvous.sImmatriculation);
                    $(self.sClass + ' .widget3Dsoft-vin').html(self.rendezvous.sVin);

                } else if (self.aModeles.length > 0 && self.rendezvous.iIdModele !== null &&
                    self.aMarques.length > 0 && self.rendezvous.iIdMarque !== null) {

                    var iIdModele = self.rendezvous.iIdModele;
                    var iIdMarque = self.rendezvous.iIdMarque;
                    $(self.sClass + ' .widget3Dsoft-modele').html(self.aModeles[iIdModele].libelle);
                    $(self.sClass + ' .widget3Dsoft-marque').html(self.aMarques[iIdMarque].libelle);
                    $(self.sClass + ' .widget3Dsoft-vin').html(self.rendezvous.sVin);
                    if (self.rendezvous.sImmatriculation !== null) {
                        $(self.sClass + ' .widget3Dsoft-immatriculation').html(self.rendezvous.sImmatriculation);
                    } else {
                        $(self.sClass + ' .widget3Dsoft-immatriculation').html('<div class="alert alert-danger" role="alert">' + self.sLanguage.VALIDATION_STEP_VEHICULE_IMMAT_UNCOMPLETE + '</div>');
                    }

                } else if (!self.oSite.bIdentifierVehicule) {
                    $(self.sClass + ' .widget3Dsoft-marque').html(self.rendezvous.sMarqueLibelle);
                    $(self.sClass + ' .widget3Dsoft-modele').html(self.rendezvous.sModeleLibelle);
                    $(self.sClass + ' .widget3Dsoft-vin').html(self.rendezvous.sVin);
                    //@todo verify each rule to respect
                    /*if(self.rendezvous.sMarqueLibelle != null && self.rendezvous.sModeleLibelle != null){
                     $(self.sClass + ' .widget3Dsoft-marque').html(self.rendezvous.sMarqueLibelle);
                     $(self.sClass + ' .widget3Dsoft-modele').html(self.rendezvous.sModeleLibelle);
                     }else{
                     
                     }*/

                } else {
                    $(self.sClass + ' .widget3Dsoft-validation-vehicules').html('<div class="alert alert-danger" role="alert">' + self.sLanguage.VALIDATION_STEP_VEHICULE_UNCOMPLETE + '</div>');
                    bAllStepValid = false;
                }


                //Interventions

                if (self.rendezvous.aInterventions.length > 0 || (self.rendezvous.aTravaux != undefined && self.rendezvous.aTravaux.length > 0)) {

                    callbackIntervention = function () {

                        for (iKeyTravaux in self.rendezvous.aTravaux) {

                            var oIntervention = self.rendezvous.aTravaux[iKeyTravaux];
                            var sLibelleItv = oIntervention._INT_LIBELLE;
                            var iDuree = oIntervention.iDureePrevue;
                            iDureeTotal += iDuree;
                            var iHeures = parseInt(iDuree / 60);
                            var  iMins = parseInt(iDuree % 60);
                            var sMins = (iMins < 10) ? '0' + iMins : iMins;
                            $(self.sClass + ' .widget3Dsoft-interventions').append('<div class="row padding-top-5"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">' + sLibelleItv + ' , ' + iHeures + 'h' + sMins + '</div></div>');

                        }

                        for (iKeyIntervention in self.rendezvous.aInterventions) {
                            var iIdIntervention = self.rendezvous.aInterventions[iKeyIntervention];


                            var oIntervention = self.oListeInterventions.getIntervention(iIdIntervention);
                            var sLibelleItv = oIntervention.libelle;
                            var iDuree = oIntervention.duree;
                            iDureeTotal += iDuree;
                            var iHeures = parseInt(iDuree / 60);
                            var iMins = parseInt(iDuree % 60);
                            var sMins = (iMins < 10) ? '0' + iMins : iMins;
                            $(self.sClass + ' .widget3Dsoft-interventions').append('<div class="row padding-top-5"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">' + sLibelleItv + ' , ' + iHeures + 'h' + sMins + '</div></div>');
                        }

                        var iDureeTotal = self.getDureeTotale(self);
                        var aDureeTotal = self.convertMinToHour(iDureeTotal)
                        $(self.sClass + ' .widget3Dsoft-interventions').append('<div class="row padding-top-5"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><b>' + self.sLanguage.INTERVENTION_DUREE_TOTALE + ' ' + aDureeTotal['sHeures'] + 'h' + aDureeTotal['sMins'] + '</div></div>');

                    }
                    iDureeTotal = 0;
                    if (self.oListeInterventions != undefined && self.oListeInterventions != null) {
                        self.aInterventions = self.searchInterventions(self, self.rendezvous.iIdModele, callbackIntervention);
                    } else {
                        callbackIntervention();
                    }

                } else {
                    $(self.sClass + ' .widget3Dsoft-validation-interventions').html('<div class="alert alert-danger" role="alert">' + self.sLanguage.VALIDATION_STEP_INTERVENTIONS_UNCOMPLETE + '</div>');
                    bAllStepValid = false;
                }

                //Dates
                if (self.rendezvous.sDateReception !== null &&
                    self.rendezvous.iHeureReception !== null &&
                    self.rendezvous.sDateRestitution !== null &&
                    self.rendezvous.iHeureRestitution !== null) {
                    //Atelier
                    //retrieveAteliers
                    if (self.aAteliers.length > 0 && self.rendezvous.iIdAtelier !== null && self.rendezvous.iIdAtelier > 0) {
                        var iIdAtelier = self.rendezvous.iIdAtelier;
                        $(self.sClass + ' .widget3Dsoft-atelier').html(self.aAteliers[iIdAtelier].sDesignation);
                    } else {
                        $(self.sClass + ' .widget3Dsoft-atelier').html(self.sLanguage.DATES_MSG_TOUS_ATELIER);
                    }

                    //Reception / Restitution
                    var aHeureReception = self.convertMinToHour(self.rendezvous.iHeureReception);
                    $(self.sClass + ' .widget3Dsoft-dateReception').html(self.formatDate(self.rendezvous.sDateReception) + ' ' + self.sLanguage.DATES_A + '  ' + aHeureReception['sHeures'] + 'h' + aHeureReception['sMins']);
                    var aHeureRestitution = self.convertMinToHour(self.rendezvous.iHeureRestitution);
                    $(self.sClass + ' .widget3Dsoft-dateRestitution').html(self.formatDate(self.rendezvous.sDateRestitution) + ' ' + self.sLanguage.DATES_A + '  ' + aHeureRestitution['sHeures'] + 'h' + aHeureRestitution['sMins']);

                    //Receptionnaire
                    var sYear = parseInt(self.rendezvous.sDateReception.substr(0, 4));
                    var sMonth = parseInt(self.rendezvous.sDateReception.substr(5, 2)) - 1; //+1 because the month id begin at 0
                    var sDay = parseInt(self.rendezvous.sDateReception.substr(8, 2));
                    self.retrieveReceptionnairesAndHours(self, sDay, sMonth, sYear, function () {
                        if (self.aReception.length > 0) {
                            if (self.rendezvous.iIdReceptionnaire !== null) {
                                $(self.sClass + ' .widget3Dsoft-receptionnaire').html(self.aReception[self.rendezvous.iIdReceptionnaire]);
                            }
                        }
                    });



                    //Veh. Courtoisie
                    if (self.rendezvous.bVehCourtoisie == true) {
                        //There is a veh courtoisie
                        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').html('<img src="' + self.sServerURL + 'img/VK.bmp" /> ');
                        if (self.rendezvous.vehCourtoisie != null) {
                            //This site manage vehicules
                            var sMarqueVehCourtoisie = self.rendezvous.vehCourtoisie.libelle_marque;
                            var sModeleVehCourtoisie = self.rendezvous.vehCourtoisie.libelle_modele;
                            $(self.sClass + ' .widget3Dsoft-vehCourtoisie').append(sMarqueVehCourtoisie + ' ' + sModeleVehCourtoisie);
                        } else {
                            $(self.sClass + ' .widget3Dsoft-vehCourtoisie').append(self.sLanguage.DATES_VEHICULE_COURTOISIE);
                        }


                    } else if (self.rendezvous.bLeClientAttend) {
                        //Le client attend
                        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').html("<img src='" + self.sServerURL + "img/ClientAttend.png'> " + self.sLanguage.DATES_CLIENT_WAIT);
                    } else if (self.rendezvous.bShuttle) {
                        $(self.sClass + ' .widget3Dsoft-vehCourtoisie').html(self.sLanguage.DATES_VEHICULE_SHUTTLE);
                    }
                } else {
                    $(self.sClass + ' .widget3Dsoft-validation-dates').html('<div class="alert alert-danger" role="alert">' + self.sLanguage.VALIDATION_STEP_DATES_UNCOMPLETE + '</div>');
                    bAllStepValid = false;
                }

                if (bAllStepValid) {
                    $(self.sClass + ' .widget3Dsoft-btnValiderRendezvous').removeAttr('disabled');
                }

                if (self.updateRdvActif) {
                    $(self.sClass + ' .widget3Dsoft-btnValiderRendezvous').html('<span class="glyphicon glyphicon-ok"></span> ' + self.sLanguage.VALIDATION_BTN_VALIDATE_UPDATE);
                    $(self.sClass + ' .widget3Dsoft-btnFermerRendezvous').show();
                }
                self.adaptDimensions(self);
                self.headerProfil(self);

                //footer
                var sHtml = '<div class="row text-center padding-top-3">';
                sHtml += ' ' + $(self.sClass + ' .btnValidFoot').html();
                sHtml += '</div">';
                $(self.sClass + ' .btnValidFoot').remove();
                $(self.sClass + ' footer').html(sHtml);

                //Events
                $(self.sClass + ' .pannelheaderVehicule').click(function () {
                    self.showFormVehicule();
                });

                $(self.sClass + ' .pannelheaderInterventions').click(function () {
                    self.showFormInterventions();
                });

                $(self.sClass + ' .pannelheaderDate').click(function () {
                    self.showFormDate();
                });

                $(self.sClass + ' .widget3Dsoft-btnValiderRendezvous').click(function () {
                    self.validerRendezvous(self);
                });

                $(self.sClass + ' .widget3Dsoft-btnFermerRendezvous').click(function () {
                    self.showFormSearchClient();
                });

                $(self.sClass + ' .widget3Dsoft-loading').hide();
            }
        );


    }
};


Widget3dsoft.prototype.validerRendezvous = function (self) {
    $(self.sClass + ' .widget3Dsoft-loading').show();
    $(self.sClass + ' .widget3Dsoft-btnValiderRendezvous').prop('disabled', 'disabled');
    if (!self.updateRdvActif) {

        self.ajax('POST',
            this.sServerURL + 'rest/rendezvous/save' + this.sParamsGet,
            self.rendezvous,
            function (response, statut) {

                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }
                if (response.success == true) {
                    self.Customer = {
                        'civilite': self.rendezvous.civilite,
                        'nom': self.rendezvous.sNom,
                        'prenom': self.rendezvous.sPrenom,
                        'tel-mobile': self.rendezvous.telmob,
                        'tel-domicile': self.rendezvous.teldom,
                        'tel-bureau': self.rendezvous.telbur,
                        'email': self.rendezvous.email,
                        'adresse': self.rendezvous.adresse,
                        'code-postal': self.rendezvous.cp,
                        'ville': self.rendezvous.ville
                    };
                    self.Vehicle = {
                        'Immatriculation': self.rendezvous.sImmatriculation,
                        'Marque-libelle': self.rendezvous.sMarqueLibelle,
                        'Modele-libelle': self.rendezvous.sModeleLibelle,
                        'Vin': self.rendezvous.sVin,
                        'Km': self.rendezvous.iKm 
                   
                    };
                    self.WorkFile = {
                        'Commentaire':self.rendezvous.sCommentaire ,
                        //Date
                        'Date-reception': self.rendezvous.sDateReception,
                        'Date-restitution': self.rendezvous.sDateRestitution,
                        'Heure-reception': self.rendezvous.iHeureReception,
                        'Heure-restitution': self.rendezvous.iHeureRestitution 
                    };

                    self.showConfirmation(self);
                } else {
                    switch (response.iCodeError) {
                        case self.aCodeError.RDV_ERROR_CODE_CLIENT:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_CLIENT);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_VEHICULE:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_VEHICULE);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_VEHICULE_CLIENT:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.CLIENT_MSG_SEARCH_FIELDS_EMPTY);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_MODELE:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_MODELE);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_INTERVENTION:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_INTERVENTION_MAX:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION_MAX);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_INTERVENTION_NOT_ALLOWED:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION_NOT_ALLOWED);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_DATE_BAD_FORMAT:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_BAD_FORMAT);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_DATE_HOUR_OUT_OF_LIMITS:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_HOUR_OUT_OF_LIMITS);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_DATE_RECEPTION_NOT_DEFINED:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_RECEPTION_NOT_DEFINED);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_DATE_NO_AVAILABILITY:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_NO_AVAILABILITY);
                            break;
                        case self.aCodeError.RDV_ERROR_CODE_RECEPTION_NOT_AVAILABLE:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_RECEPTION_NOT_AVAILABLE);
                            break;
                        default:
                            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE);
                            break;
                    }
                    $(self.sClass + ' article').scrollTop(0);
                    $(self.sClass + ' .widget3Dsoft-message').show();

                }
         self.jCalendrier=[];

                $(self.sClass + ' .widget3Dsoft-loading').hide();
            }, true
        );


    } else {

        self.ajax('POST',
            this.sServerURL + 'rest/rendezvous/update' + this.sParamsGet,
            self.rendezvous,
            function (response, statut) {

                if (bIEOld3Dsoft) {
                    response = JSON.parse(response);
                }

                if (response.success == true) {
                 
                    self.Customer = {
                        civilite: self.rendezvous.civilite,
                        nom: self.rendezvous.sNom,
                        prenom: self.rendezvous.sPrenom,
                        telmob: self.rendezvous.telmob,
                        teldom: self.rendezvous.teldom,
                        telbur: self.rendezvous.telbur,
                        email: self.rendezvous.email,
                        adresse: self.rendezvous.adresse,
                        cp: self.rendezvous.cp,
                        ville: self.rendezvous.ville
                    };
                    self.Vehicle = {
                        immatriculation: self.rendezvous.sImmatriculation,
                        marqueLibelle: self.rendezvous.sMarqueLibelle,
                        modeleLibelle: self.rendezvous.sModeleLibelle,
                        vin: self.rendezvous.sVin,
                        km: self.rendezvous.iKm 
                   
                    };
                    self.WorkFile = {
                        Interventions: self.rendezvous.aInterventions,
                        Commentaire:self.rendezvous.sCommentaire ,
                        //Date
                        DateReception: self.rendezvous.sDateReception,
                        DateRestitution: self.rendezvous.sDateRestitution,
                        HeureReception: self.rendezvous.iHeureReception,
                        HeureRestitution: self.rendezvous.iHeureRestitution 
                    };
                    $(self.sClass + ' .widget3Dsoft-loading').hide();
                    self.showConfirmation(self);
                } else {
                    self.showErrorValidation(self, response.iCodeError);
                }
            }, true
        );

    }

    Widget3dsoft.prototype.showErrorValidation = function (self, iCodeError) {
        switch (iCodeError) {
            case self.aCodeError.RDV_ERROR_CODE_CLIENT:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_CLIENT);
                break;
            case self.aCodeError.RDV_ERROR_CODE_VEHICULE:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_VEHICULE);
                break;
            case self.aCodeError.RDV_ERROR_CODE_VEHICULE_CLIENT:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.CLIENT_MSG_SEARCH_FIELDS_EMPTY);
                break;
            case self.aCodeError.RDV_ERROR_CODE_MODELE:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_MODELE);
                break;
            case self.aCodeError.RDV_ERROR_CODE_INTERVENTION:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION);
                break;
            case self.aCodeError.RDV_ERROR_CODE_INTERVENTION_MAX:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION_MAX);
                break;
            case self.aCodeError.RDV_ERROR_CODE_INTERVENTION_NOT_ALLOWED:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_INTERVENTION_NOT_ALLOWED);
                break;
            case self.aCodeError.RDV_ERROR_CODE_DATE_BAD_FORMAT:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_BAD_FORMAT);
                break;
            case self.aCodeError.RDV_ERROR_CODE_DATE_HOUR_OUT_OF_LIMITS:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_HOUR_OUT_OF_LIMITS);
                break;
            case self.aCodeError.RDV_ERROR_CODE_DATE_RECEPTION_NOT_DEFINED:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_RECEPTION_NOT_DEFINED);
                break;
            case self.aCodeError.RDV_ERROR_CODE_DATE_NO_AVAILABILITY:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_DATE_NO_AVAILABILITY);
                break;
            case self.aCodeError.RDV_ERROR_CODE_RECEPTION_NOT_AVAILABLE:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE_RECEPTION_NOT_AVAILABLE);
                break;
            default:
                $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.VALIDATION_RDV_ERROR_CODE);
                break;
        }
        $(self.sClass + ' article').scrollTop(0);
        $(self.sClass + ' .widget3Dsoft-message').show();
    };

};